module.exports = __webpack_public_path__ + "img/avatar0.89b74dd9.png";